<template>
    <b-container fluid>
        <b-row no-gutters>
            <b-col v-if="ishost">
                <b-button-toolbar>
                    <b-button-group size="sm">
                        <b-button v-on:click="initRTM" :disabled="ready.value">Init</b-button>
                        <b-button v-on:click="connectChannel" :disabled="!ready.value || connected.value">Connect Channel</b-button>
                        <b-button v-on:click="leaveChannel" :disabled="!connected.value">Leave Channel</b-button>
                    </b-button-group>
                </b-button-toolbar>
            </b-col>
        </b-row>
        <b-row no-gutters>
            <b-col>
                <status-panel :status="statuspanel" style="min-width:200px;"></status-panel>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import moment from "moment";
    moment.locale('IT');

    import AgoraRTM from 'agora-rtm-sdk';
    import StatusPanel from "./StatusPanel";

    export default {
        name: "Agora_RTM",
        props: {
            ishost: {
                type: Boolean,
                default: false
            },
            autoconnect: {
                type: Boolean,
                default: false
            },
            username: {
                type: String
            },
            channel: {
                type: String
            }
        },
        components:{
            StatusPanel
        },
        data: function () {
            return {
                option: {
                    appID: "eda5d991b3664dcda82ef22799493c5b",
                    token: null
                },
                rtm:{
                    client: null,
                    channel: null,
                    members: {}
                },
                ready: {label: 'Rdy', variant: 'outline-dark', value: false},
                connected: {label: 'Con', variant: 'outline-dark', value: false},
                statuspanel: [],
                selecteduser: null
            }
        },
        watch: {
            username: function (val) {
                if(this.autoconnect && val !== undefined){
                    this.connectChannel();
                }
            }
        },
        methods:{
            initRTM(){
                //init RTM Client
                this.rtm.client = AgoraRTM.createInstance(this.option.appID);
                this.rtm.client.on('ConnectionStateChange', (newState, reason) => {
                    console.log('on connection state changed to ' + newState + ' reason: ' + reason);
                });
                this.ready.value = true;
            },
            connectChannel() {
                this.rtm.client.login({ token: this.option.token, uid: this.username }).then(() => {
                    console.log('AgoraRTM client login success');
                    this.rtm.channel = this.rtm.client.createChannel(this.channel);

                    this.rtm.channel.on('MemberJoined', (_memberid) => {
                        this.$emit('memberJoin', _memberid);
                    });
                    this.rtm.channel.on('MemberLeft', (_memberid) => {
                        this.$emit('memberLeft', _memberid);
                    });
                    this.rtm.channel.on('ChannelMessage', this.onMessage);

                    this.rtm.channel.join().then(() => {
                        console.log("join channel: success");
                        this.listChannelMembers()
                        this.connected.value = true;
                    }).catch(error => {
                        /* Your code for handling the event of a join-channel failure. */
                        console.log('AgoraRTM join-channel failure:', error);
                    });

                }).catch(err => {
                    console.log('AgoraRTM client login failure', err);
                });
            },
            leaveChannel() {
                // Leave the RTM channel
                if(this.rtm.channel){
                    this.rtm.channel.leave();
                }

                if(this.rtm.client){
                    this.rtm.client.logout();
                }

                this.connected.value = false;
                this.rtm.members = {};
            },
            listChannelMembers(_memberid) {

                console.log(_memberid);

                this.rtm.channel.getMembers().then((channelmembers) => {
                    /*this.rtm.members = {};
                    // this.rtm.members.sort();
                    for(const m of channelmembers) {
                        if(m !== this.uid){
                            this.$set(this.rtm.members, m, this.createChannelMember(m));
                        }
                    }*/
                    if (channelmembers.length > 0){
                        this.$emit('publishmembers', channelmembers);
                    } else{
                        this.$emit('publishmembers', null);
                    }
                })
            },
            memberJoin(_memberid){
                this.$emit('memberJoin', _memberid);
            },
            memberLeft(_memberid) {
                this.$emit('memberLeft', _memberid);
            },
            sendCommand: function (_data) {
                if(this.rtm.channel){
                    let payload = JSON.stringify(_data);
                    this.rtm.channel.sendMessage({text: payload}).then(() => {
                        /* Your code for handling events, such as a channel message-send success. */
                    }).catch(error => {
                        /* Your code for handling events, such as a channel message-send failure. */
                        console.log(error);
                    });
                }
            },
            sendTextMessage: function (_textmessage) {
                if(this.rtm.channel) {
                    this.rtm.channel.sendMessage({text: _textmessage}).then(() => {
                        /* Your code for handling events, such as a channel message-send success. */
                    }).catch(error => {
                        /* Your code for handling events, such as a channel message-send failure. */
                        console.log(error);
                    });
                }
            },
            onMessage: function(_message) {
                try {
                    // try to parse json if command
                    let json = JSON.parse(_message.text);
                    this.$emit('command', json);
                } catch (error) {
                    console.log('LOG:', _message.text);
                }
            },
            notifyCoHost: function() {
                /*
                this.rtm.client.getChannelAttributes(this.channel).then( (attributes) => {
                    console.log('------------------>', attributes);
                    this.rtm.client.addOrUpdateChannelAttributes(this.channel, undefined);
                })
                */
                //this.rtm.channel.addOrUpdateChannelAttributes(this.channel, undefined, undefined);
            }
        },
        mounted() {
            this.$nextTick(function () {
                this.initRTM();
                window.addEventListener('beforeunload', this.leaveChannel);
                this.statuspanel.push(this.ready);
                this.statuspanel.push(this.connected);
            })
        },
        beforeDestroy() {
            window.removeEventListener('beforeunload', this.leaveChannel);
            this.leaveChannel();
        },
    }
</script>

<style scoped>

</style>
